import { PERIODS } from 'constants/periods';

import { isSatisfyOption } from 'shared/lib';

import type { TCreditFormCommonFields, TCreditFormDictionaries, TCreditFormDictionaryName } from 'entities/creditForm';

const CreditFormDictionaryFields: Partial<Record<keyof TCreditFormCommonFields, TCreditFormDictionaryName>> = {
  purpose: 'purposes',
  autoBrand: 'autoBrands',
  autoModel: 'autoModels',
  autoYear: 'autoYears',
  employmentType: 'employmentTypes',
  unemploymentReason: 'unemploymentReasons',
  areaOfEmployment: 'areasOfEmployment',
  employerType: 'employerTypes',
  education: 'educations',
  maritalStatus: 'maritalStatuses',
  numberOfDependents: 'numberOfDependentsTypes',
  additionalPhoneOwner: 'additionalPhoneOwners',
  carAvailability: 'carAvailabilityTypes',
  propertyTypeAvailability: 'propertyTypeAvailabilityTypes',
  period: 'periods',
};

export const convertDictionaryField = (
  value: unknown,
  key: keyof TCreditFormCommonFields,
  dictionaries?: TCreditFormDictionaries,
) => {
  const dictionaryName = CreditFormDictionaryFields[key];

  if (!dictionaryName || !value) {
    return null;
  }

  if (isSatisfyOption(['autoModels', 'autoYears'], dictionaryName)) {
    return {
      value,
      label: value,
      data: { isPrefilled: true },
    } as TCreditFormCommonFields['autoModel'];
  }

  const dictionary = dictionaries?.[dictionaryName] as Dictionaries.TSelectOption[];

  if (!dictionary) {
    return null;
  }

  const dictionaryValue = dictionary.findIndex(
    (item) =>
      String(dictionaryName === 'autoBrands' ? item.label : item.value)
        .trim()
        .toLowerCase() === String(value).trim().toLowerCase(),
  );

  if (dictionaryValue === -1) {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'purpose': {
        return dictionary[dictionary.findIndex((item) => item.value === 'Money')];
      }
      case 'period': {
        return dictionary[dictionary.findIndex((item) => item.value === PERIODS.defaultFormValue)];
      }
    }
  }

  return dictionary[dictionaryValue];
};
